/* DELACRUZ GRILLZ · Configurador · galería «Inspírate» con diseños de ejemplo que se cargan en la dentadura */
(function(){
  var SPRITE = window.DLC_IDEAS_SPRITE || '';
  var IDEAS = [
    {h:'gc-11fop214-21fop724', t:'Tu país, con su forma', d:'República Dominicana y España en oro. Vale cualquier país del mundo.', p:270},
    {h:'gc-11gcp170-21gcp862', t:'País grabado', d:'Colombia y Venezuela grabados sobre cromo.', p:250},
    {h:'gc-11foqAFR-21foq504', t:'País en ventana', d:'África y Marruecos calados en oro.', p:270},
    {h:'gc-11fotgD-21fotgG', t:'Iniciales', d:'Tus letras en gótica y en oro. Hay 6 tipos de letra.', p:270},
    {h:'gc-13gctfA-12gctfD-11gctfR-21gctfI-22gctfA-23gctfN', t:'Nombre grabado', d:'ADRIAN grabado arriba con letra graffiti, una letra por diente.', p:640},
    {h:'gc-11fotb2-21fotb4', t:'Tu número', d:'Tu dorsal, tu año o tu código postal, con forma y en oro.', p:270},
    {h:'gc-12fctbL-11fctbU-21fctbN-22fctbA', t:'Nombre con forma', d:'Una letra por diente, en cromo.', p:360},
    {h:'gc-12goe-22goh', t:'Estrella y corazón', d:'Figuras grabadas en oro.', p:370},
    {h:'gc-13fcl-23fcl', t:'Llamas', d:'Colmillos con forma de llama en cromo.', p:210},
    {h:'gc-z4342xc-z4241xc-z4131xc-z3132xc-z3233xc', t:'Destellos', d:'5 estrellas de 4 puntas abajo: una en el centro y dos a cada lado.', p:400},
    {h:'gc-13cc-23cc-12vo-11vo-21vo-22vo', t:'Colmillos y ventanas', d:'Colmillos afilados en cromo y ventanas en oro.', p:400},
    {h:'gc-13kcv-23kcv-z1121kc', t:'Cruces', d:'Cruces en ventana en los colmillos y otra entre los dientes de delante.', p:470}
  ];
  var N = IDEAS.length;

  var CSS =
  '.dlc .dlc-insp{display:grid;gap:14px;min-width:0}' +
  '.dlc .dlc-insp-head{display:flex;align-items:flex-end;justify-content:space-between;gap:12px}' +
  '.dlc .dlc-insp .h2{margin:0}' +
  '.dlc .dlc-insp-lede{margin:6px 0 0;color:var(--muted,#a1a1a6);font:15px/1.45 -apple-system,BlinkMacSystemFont,"SF Pro Text",Inter,system-ui,sans-serif;max-width:56ch}' +
  '.dlc .dlc-insp-tags{display:flex;flex-wrap:wrap;gap:6px;margin-top:10px}' +
  '.dlc .dlc-insp-tags span{font:600 12px -apple-system,BlinkMacSystemFont,"SF Pro Text",Inter,system-ui,sans-serif;color:#111;background:#ffd60a;border-radius:999px;padding:5px 10px}' +
  '.dlc .dlc-insp-list{display:grid;grid-template-columns:repeat(4,minmax(0,1fr));gap:12px;margin:0;padding:0;list-style:none}' +
  '.dlc .dlc-card{display:grid;grid-template-rows:auto 1fr;background:rgba(255,255,255,.065);border:.5px solid rgba(255,255,255,.14);border-radius:20px;overflow:hidden;min-width:0;transition:transform .2s cubic-bezier(.32,.72,0,1),border-color .2s}' +
  '.dlc .dlc-card:hover{border-color:rgba(255,214,10,.6)}' +
  '.dlc .dlc-card:active{transform:scale(.98)}' +
  '.dlc .dlc-card-img{display:block;width:100%;aspect-ratio:600/396;background-color:#f08f95;background-size:100% ' + (N*100) + '%;background-repeat:no-repeat}' +
  '.dlc .dlc-insp-list>li{display:grid}' +
  '.dlc .dlc-card-body{display:flex;flex-direction:column;gap:4px;padding:12px 14px 14px}' +
  '.dlc .dlc-card-body b{font:700 16px/1.2 -apple-system,BlinkMacSystemFont,"SF Pro Text",Inter,system-ui,sans-serif;letter-spacing:-.01em;color:#f5f5f7}' +
  '.dlc .dlc-card-body p{margin:0;font:13px/1.4 -apple-system,BlinkMacSystemFont,"SF Pro Text",Inter,system-ui,sans-serif;color:#a1a1a6}' +
  '.dlc .dlc-card-foot{display:flex;align-items:center;justify-content:space-between;gap:8px;margin-top:auto;padding-top:8px}' +
  '.dlc .dlc-card-foot small{font:600 13px -apple-system,BlinkMacSystemFont,"SF Pro Text",Inter,system-ui,sans-serif;color:#f5f5f7;font-variant-numeric:tabular-nums}' +
  '.dlc .dlc-card-foot button{border:0;border-radius:999px;background:#ffd60a;color:#111;font:700 13px -apple-system,BlinkMacSystemFont,"SF Pro Text",Inter,system-ui,sans-serif;padding:8px 14px;cursor:pointer;box-shadow:0 6px 16px rgba(255,214,10,.2)}' +
  '.dlc .dlc-card-foot button:active{transform:scale(.95)}' +
  '.dlc .dlc-card-foot button:focus-visible{outline:2px solid #fff;outline-offset:2px}' +
  '.dlc .dlc-insp-fine{margin:0;font:12px/1.4 -apple-system,BlinkMacSystemFont,"SF Pro Text",Inter,system-ui,sans-serif;color:#8e8e93}' +
  '@media (max-width:1100px){.dlc .dlc-insp-list{grid-template-columns:repeat(3,minmax(0,1fr))}}' +
  '@media (max-width:860px){' +
    '.dlc .dlc-insp-list{display:flex;overflow-x:auto;scroll-snap-type:x mandatory;gap:10px;margin-inline:calc(-1 * max(16px,env(safe-area-inset-left,0px)));padding:2px max(16px,env(safe-area-inset-left,0px)) 6px;scrollbar-width:none}' +
    '.dlc .dlc-insp-list::-webkit-scrollbar{display:none}' +
    '.dlc .dlc-insp-list>li{flex:0 0 72%;scroll-snap-align:start;display:grid}' +
  '}';

  function ready(fn){
    var tries = 0;
    (function wait(){
      var main = document.querySelector('.dlc .main');
      if (main) return fn(main);
      if (++tries < 100) setTimeout(wait, 100);
    })();
  }

  ready(function(main){
    if (document.querySelector('.dlc-insp')) return;
    var st = document.createElement('style'); st.textContent = CSS; document.head.appendChild(st);

    var sec = document.createElement('section');
    sec.className = 'dlc-insp'; sec.setAttribute('aria-labelledby', 'dlc-insp-t');
    var html =
      '<div class="dlc-insp-head"><div>' +
        '<p class="eyebrow">Ideas</p>' +
        '<h2 class="h2" id="dlc-insp-t">Inspírate</h2>' +
        '<p class="dlc-insp-lede">Todo esto se puede hacer y combinar. Toca «Probar» y lo verás en la dentadura de arriba para cambiarlo a tu gusto.</p>' +
        '<div class="dlc-insp-tags" aria-label="Qué se puede hacer"><span>Cualquier país con su forma</span><span>Letras y nombres</span><span>Números</span><span>Grabados</span><span>Figuras</span></div>' +
      '</div></div><ul class="dlc-insp-list">';
    IDEAS.forEach(function(it, i){
      var pos = N > 1 ? (i / (N - 1) * 100) : 0;
      html += '<li><article class="dlc-card">' +
        '<span class="dlc-card-img" role="img" aria-label="' + it.t + '" style="background-image:url(\'' + SPRITE + '\');background-position:0 ' + pos.toFixed(4) + '%"></span>' +
        '<div class="dlc-card-body"><b>' + it.t + '</b><p>' + it.d + '</p>' +
        '<div class="dlc-card-foot"><small>' + it.p + ' €</small><button type="button" data-h="' + it.h + '">Probar</button></div></div>' +
      '</article></li>';
    });
    html += '</ul><p class="dlc-insp-fine">Precios orientativos con molde en clínica. Si tienes otra idea, diséñala arriba o escríbenos a @delacruzgrillz.</p>';
    sec.innerHTML = html;
    main.parentNode.insertBefore(sec, main.nextSibling);

    sec.addEventListener('click', function(e){
      var b = e.target.closest('button[data-h]'); if (!b) return;
      var h = b.getAttribute('data-h');
      if (location.hash.slice(1) === h) { try { history.replaceState(null, '', location.pathname + location.search); } catch (_) {} }
      location.hash = h;
      var stage = document.querySelector('.dlc .stage');
      if (stage) stage.scrollIntoView({behavior: 'smooth', block: 'start'});
    });
  });
})();
